import { render, staticRenderFns } from "./FoodGroups.vue?vue&type=template&id=d7667e4a&scoped=true&"
import script from "./FoodGroups.vue?vue&type=script&lang=js&"
export * from "./FoodGroups.vue?vue&type=script&lang=js&"
import style0 from "./FoodGroups.vue?vue&type=style&index=0&id=d7667e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7667e4a",
  null
  
)

export default component.exports